import {mmodal} from './modal';
import {bindModalForm, bindForm} from "./bindForm";
import {Breadcrumbs} from "./Breadcrumbs";
import {LazyLoadBlock} from  "./lazyLoadBlock";
import {PhoneMask} from "./PhoneMask";
import {fixHeader} from "./fixHeader";

function hideListItems(){
    let listItems = document.querySelectorAll('.js-productMain__list-item')
    if (listItems.length > 5){
        for(let i =5; i<=listItems.length -1; i++){
            listItems[i].classList.add('productMain__list-item_hidden')
        }
        addButtonAfterList()
        addButtonClick(listItems)
    }
}

function addButtonAfterList(){
    document.querySelector('.js-productMain-list').insertAdjacentHTML('afterend', `<button class="productMain__list-button js-productMain-button">Подробнеe</button>`)
}

function addButtonClick(nodelist){
    document.querySelector('.js-productMain-button').addEventListener('click',function(){
        for(let i =5; i<=nodelist.length -1; i++){
            nodelist[i].classList.toggle('productMain__list-item_hidden')
        }
        if(this.innerText = "Подробнее"){
            this.innerText = "Скрыть"
        }else {
            this.innerText = "Подробнее"
        }
    })

}

function addHeaderFixed(){
    document.querySelector('header').classList.add('header_fixed')
}

function offsetPosition(element) {
    let offsetTop = 0;
    do {
        offsetTop  += element.offsetTop;
    } while (element = element.offsetParent);
    return offsetTop;
}

function scrollToLeazing(){
    let header = document.querySelector('.header_fixed')
    let headerHeight =header.offsetHeight
    let lizingButton = document.querySelector('[data-content="content-lizing"]')

    offsetPosition(lizingButton)
    window.scrollTo({
        top: (offsetPosition(lizingButton) - headerHeight),
        behavior: "smooth"
    });

}

window.initCollapseTable = function() {

    var bindExpandService = function (block) {
        var button = block.querySelector('.js-more-btn');
        var strTable = block.querySelectorAll('table tbody tr')
        block.classList.add('is-hidden');

        if(strTable !== null){

            if(strTable.length <= 1 || strTable.length <= 2){
                block.classList.add('is-button-hide');
                block.classList.remove('is-hidden');
            }
        }

        button.addEventListener('click', function () {
            button.classList.toggle('is-open')
            block.classList.toggle('is-hidden');
            if (button.innerText.toLowerCase() === 'больше моделей') {
                button.innerText = 'Свернуть';
            } else {
                button.innerText = 'Больше моделей';
            }
        })
    }


    var blocksService = document.querySelectorAll('.js-hidden-container');

    if (blocksService.length) {
        for (var i = 0; i < blocksService.length; i += 1) {
            bindExpandService(blocksService[i]);
        }
    }
}

window.initPreviewSlider = function() {
    let productPreview  = [...document.querySelectorAll('.product-card__top')]

    productPreview.forEach(function(el){
        let id = el.getAttribute('id')
        let slideElement = el.querySelectorAll('.swiper-slide')


        if(slideElement.length > 1){
            const categorySlider = new Swiper(('#' + id + ' .swiper'), {
                spaceBetween: 0,
                slidesPerView: 1,
                navigation: {
                    prevEl: ".js-navigation-prev_" + id,
                    nextEl: ".js-navigation-next_" + id,
                },
            })
        }
    })
}

window.initCollapseText = function() {
    let productCardDesc = document.querySelectorAll('.product-card__desc');

    for (var p = 0; p < productCardDesc.length; p += 1) {
        let deskItem = productCardDesc[p];
        let hiddenText = deskItem.querySelector('.is-hidden-text')
        let btnMoreText = deskItem.querySelector('.js-more-text')

        if(btnMoreText){
            btnMoreText.addEventListener('click', function(){
                btnMoreText.classList.toggle('is-open')
                if (btnMoreText.innerText.toLowerCase() === 'развернуть') {
                    btnMoreText.innerText = 'Свернуть';
                    hiddenText.style.display = "inline-block"
                } else {
                    btnMoreText.innerText = 'Развернуть';
                    hiddenText.style.display = "none"
                }
            })
        }
    }
}

window.addEventListener('load', () => {
    function addScrollToLizing() {
        if (document.querySelectorAll('.js-productMain-button-lizing').length) {
            let lizingLink = document.querySelector('.js-productMain-button-lizing')
            lizingLink.addEventListener('click', function () {

                addHeaderFixed()
                scrollToLeazing()
            })
        }
    }

    hideListItems();
    fixHeader();
    addScrollToLizing();
    const bindBurger = (node) => {
        if (!node) {
            return false;
        }
        node.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.toggle('body_menu-open');
        });

        document.querySelector('.header__mobile-close').addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.toggle('body_menu-open');
        });
    }
    bindBurger(document.querySelector('.header__navbutton'));

    // hover инфографика
    const bindInfographicsHover = (node) => {
        if (!node) {
            return false;
        }
        const elements = node.querySelectorAll('.infograph__list-item');

        for (const element of elements) {
            const targetClass = `infograph_hover-${element.dataset.hover}`;
            element.addEventListener('mouseenter', () => {
                node.classList.add(targetClass);
            })
            element.addEventListener('mouseleave', () => {
                node.classList.remove(targetClass);
            })
        }

        return true;
    }
    bindInfographicsHover(document.querySelector('.infograph'));

    // swiper в каталоге
    const bindCatalogSwiper = (node, windowWidth = 1170) => {
        if (!node) {
            return false;
        }

        const swiperNode = node.classList.contains('swiper') ? node : node.querySelector('.swiper');
        let swiperInstance;

        const swiperSettings = {
            slidesPerView: 2,
            spaceBetween: 30,
            navigation: {
                prevEl: node.querySelector('.swiper-control_prev'),
                nextEl: node.querySelector('.swiper-control_next'),
            },
            breakpoints: {
                760: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                }
            }
        };

        const activateAdaptive = () => {
            if (!swiperInstance && window.matchMedia(`(max-width:${windowWidth}px)`).matches) {
                swiperInstance = new Swiper(swiperNode, swiperSettings);
            } else if (swiperInstance && !window.matchMedia(`(max-width:${windowWidth}px)`).matches) {
                swiperInstance.destroy();
                swiperInstance = null;
            }
        }

        activateAdaptive();
        window.addEventListener('resize', activateAdaptive);
    }

    bindCatalogSwiper(document.querySelector('.m-section-list'));

    // разворачивание блоков с текстом
    const bindExpandableBlock = (node) => {
        if (!node) {
            return false;
        }
        const actionButton = node.querySelector('.btn');

        if (!actionButton) {
            return false;
        }

        const buttonInnerSpan = actionButton.querySelector('span');
        actionButton.addEventListener('click', () => {
            node.classList.toggle('seo-block_open');
            actionButton.classList.toggle('btn_arrow');
            buttonInnerSpan.innerText = buttonInnerSpan.innerText === 'Подробнее' ? 'Свернуть' : 'Подробнее';
        });
    }

    for (const expandableBlock of document.querySelectorAll('.seo-block_expandable')) {
        bindExpandableBlock(expandableBlock);
    }

    // подсветка линии в каталоге при наведении на ссылку товара
    const highlightCatalogLine = (link) => {
        if (!link && !link.classList.contains('catalog-table__link')) {
            return false;
        }
        link.addEventListener('mouseenter', () => {
            link.closest('.catalog-table__item').classList.toggle('catalog-table__item_hover');
        });
        link.addEventListener('mouseleave', () => {
            link.closest('.catalog-table__item').classList.toggle('catalog-table__item_hover');
        })
    }

    for (const catalogLink of document.querySelectorAll('.catalog-table__link')) {
        highlightCatalogLine(catalogLink);
    }

    // сортировка псевдо select
    /* * / const bindSelect = (node) => {
        if (!node || !node.classList.contains('js-sort')) {
            return false;
        }

        node.querySelector('.catalog-sort__active-value').innerText = node.querySelector('.catalog-sort__dropdown-item_active').innerText;

        const handleDocumentClick = (e) => {
            if (!node.contains(e.target)) {
                closeDropdown();
            }
        }

        const showDropdown = () => {
            node.classList.add('catalog-sort_active');
            document.addEventListener('click', handleDocumentClick)
        }

        const closeDropdown = () => {
            node.classList.remove('catalog-sort_active');
            document.removeEventListener('click', handleDocumentClick);
        }

        const changeValue = (el) => {
            node.querySelector('.catalog-sort__active-value').innerText = el.innerText;
            node.querySelector('.catalog-sort__dropdown-item_active').classList.remove('catalog-sort__dropdown-item_active');
            el.classList.add('catalog-sort__dropdown-item_active');
            closeDropdown();
        }

        for (item of node.querySelectorAll('.catalog-sort__dropdown-item')) {
            item.addEventListener('click', (e) => {
                changeValue(e.target);
            })
        }

        const activeNode = node.querySelector('.catalog-sort__active');
        activeNode.addEventListener('click', showDropdown);
        document.addEventListener('keydown', (e) => {

            [...node.querySelectorAll('.catalog-sort__dropdown-item')].map((el) => {
                if (document.activeElement === el && e.code === 'Space') {
                    e.preventDefault();
                    changeValue(el);
                    window.location = el.href;
                    return false;
                }
            })

            if (document.activeElement === activeNode && (e.code === 'Space' || e.code === 'Enter')) {
                e.preventDefault();
                showDropdown();
                node.querySelectorAll('.catalog-sort__dropdown-item')[1].focus();
                return false;
            }
        });

    }

    bindSelect(document.querySelector('.js-sort'));
    /**/
        const applyAdaptive = (breakpoint, belowCb, aboveCb, adaptiveFlag = false) => {

            if (!adaptiveFlag && window.matchMedia(`(max-width: ${breakpoint}px)`).matches) {
                belowCb();
                return true;
            }
            if (adaptiveFlag && window.matchMedia(`(min-width: ${breakpoint}px)`).matches) {
                aboveCb();
                return false;
            }
            return adaptiveFlag;
        }

        // адаптив таблицы каталога
        const bindCatalogAdaptive = (node) => {
            if (!node) {
                return false;
            }

            const rows = node.querySelectorAll('thead tr, tbody tr');

            const headCells = [...node.querySelectorAll('thead th')];
            const propCellsObj = headCells.reduce((acc, el, index) => {
                if (!el.classList.contains('catalog-table__prop-cell')) {
                    return acc;
                }
                return {
                    startIndex: acc.startIndex ? acc.startIndex : index,
                    endIndex: index,
                };
            }, {
                startIndex: null,
                endIndex: headCells.length - 1,
            });

            const hideProps = (rows, startIndex, endIndex) => {
                for (const row of rows) {
                    const elements = [...row.querySelectorAll('td, th')]
                        .filter((el, index) => (index >= startIndex) && (index <= endIndex))
                        .map((el, index) => {
                            if (index > 0) {
                                el.classList.add('hidden');
                            }
                            return el;
                        });
                }
                node.setAttribute('data-current-index', '0');
            }

            const slideProps = (method='inc') => {
                const {startIndex, endIndex} = propCellsObj;
                const currentIndex = Number(node.getAttribute('data-current-index')) || 0;
                const propsLength = endIndex - startIndex;
                let newIndex = 0;

                switch (method) {
                    case 'inc': {
                        newIndex = currentIndex === propsLength - 1 ? 0 : currentIndex + 1;
                        break;
                    }
                    case 'dec': {
                        newIndex = currentIndex === 0 ? propsLength - 1 : currentIndex - 1;
                        break;
                    }
                }

                node.setAttribute('data-current-index', String(newIndex));

                const toggleHiddenOnRowItems = (row) => {
                    const filtered = [...row.querySelectorAll('th, td')]
                        .filter((el, index) => (index >= startIndex) && (index <= endIndex));

                    filtered.map((el, index) => {
                        if (index === newIndex) {
                            el.classList.remove('hidden');
                            return true;
                        }
                        el.classList.add('hidden');
                        return true;
                    })
                }

                for (const row of rows) {
                    toggleHiddenOnRowItems(row);
                }
            }

            const addSliderControls = (startIndex, endIndex) => {
                const headCells = node.querySelectorAll('thead th');
                const firstCell = headCells[startIndex - 1];
                const endCell = headCells[endIndex + 1];

                const prevButton = document.createElement('button');
                prevButton.setAttribute('type', 'button');
                prevButton.className = 'catalog-table__control catalog-table__control_prev';
                prevButton.addEventListener('click', () => {
                    slideProps('dec')
                })

                const nextButton = document.createElement('button');
                nextButton.setAttribute('type', 'button');
                nextButton.className = 'catalog-table__control catalog-table__control_next';
                nextButton.addEventListener('click', () => {
                    slideProps('inc')
                });

                firstCell.append(prevButton);
                endCell.append(nextButton);
            }

            addSliderControls(propCellsObj.startIndex, propCellsObj.endIndex);
            hideProps(rows, propCellsObj.startIndex, propCellsObj.endIndex);
            slideProps(rows, propCellsObj.startIndex, propCellsObj.endIndex);
        }
        const destroyCatalogAdaptive = (node) => {
            if (!node) {
                return false;
            }
            for (const control of node.querySelectorAll('.catalog-table__control')) {
                control.remove();
            }

            for (const cell of node.querySelectorAll('th.hidden, td.hidden')) {
                cell.classList.remove('hidden');
            }
        }

        const catalogTable = document.querySelector('.js-catalog-table');
        if (window.matchMedia('(max-width: 1000px)').matches) {
            bindCatalogAdaptive(catalogTable);
        }
        let catalogAdaptiveFlag = false;
        window.addEventListener('resize', () => {
            catalogAdaptiveFlag = applyAdaptive('1000',
                () => {bindCatalogAdaptive(catalogTable)},
                () => {destroyCatalogAdaptive(catalogTable)},
                catalogAdaptiveFlag);
        });

        // галерея в товаре
        const bindProductGallery = (node) => {
            if (!node) {
                return false;
            }

            const sliderThumbs = new Swiper(node.querySelector('.product__gallery-thumbs .swiper'), {
                spaceBetween: 20,
                slidesPerView: 4,
                freeMode: true,
                watchSlidesProgress: true,
                navigation: {
                    prevEl: ".product__gallery-thumbs-control_prev",
                    nextEl: ".product__gallery-thumbs-control_next",
                },
            })

            const sliderTop = new Swiper(node.querySelector('.product__gallery-top .swiper'), {
                spaceBetween: 10,
                thumbs: {
                    swiper: sliderThumbs,
                },
            });
        };
        bindProductGallery(document.querySelector('.product__gallery'));

        // разворачивание .expandable-block
        const handleExpandableBlock = (node) => {
            if (!node
                || !node.querySelector('.expandable-block__inner')
                || node.offsetHeight < 320) {
                return false;
            }

            node.classList.add('expandable-block_hidden');

            const buttonMore = document.createElement('button');
            buttonMore.className = 'expandable-block__toggle';
            buttonMore.innerText = 'Развернуть';

            buttonMore.addEventListener('click', () => {
                node.classList.toggle('expandable-block_hidden');
                buttonMore.innerText = buttonMore.innerText === 'Развернуть' ? 'Свернуть' : 'Развернуть';
                buttonMore.classList.toggle('expandable-block__toggle_opened');
            })

            node.append(buttonMore);
        };
        for (const block of document.querySelectorAll('.js-expandable-block')) {
            handleExpandableBlock(block);
        };

        const bindTabs = (node) => {
            if (!node) {
                return false;
            }

            const toggles = node.querySelectorAll('.tabs__head-item');
            const contents = node.querySelectorAll('.tabs__item');

            const activateTab = (hash) => {
                for (const toggle of toggles) {
                    const target = toggle.getAttribute('href');
                    if (target === hash) {
                        toggle.classList.add('tabs__head-item_active');
                        continue;
                    }
                    toggle.classList.remove('tabs__head-item_active');
                }

                for (const content of contents) {
                    const contentId = content.getAttribute('id');
                    if (`#${contentId}` === hash) {
                        content.classList.remove('tabs__item_hidden');
                        continue;
                    }
                    content.classList.add('tabs__item_hidden');
                }
            };

            activateTab(toggles[0].getAttribute('href'));

            for (const toggle of toggles) {
                toggle.addEventListener('click', (e) => {
                    e.preventDefault();
                    activateTab(toggle.getAttribute('href'));
                });
                document.addEventListener('keypress', (e) => {
                    if (document.activeElement === toggle && (e.code === 'Space' || e.code === 'Enter')) {
                        e.preventDefault();
                        activateTab(toggle.getAttribute('href'));
                    }
                })
            }
        };

        for (const tabs of document.querySelectorAll('.js-tabs')) {
            bindTabs(tabs);
        }

        // переключение dt
        const bindDt = (node) => {
            if (!node) {
                return false;
            }
            for (const dt of node.querySelectorAll('dt')) {
                dt.addEventListener('click', (e) => {
                    e.preventDefault();
                    node.querySelector('.product-features__active').classList.remove('product-features__active');
                    e.target.classList.add('product-features__active');
                })
            }
        };
        for (const dl of document.querySelectorAll('.product-features dl')) {
            bindDt(dl);
        }


        // инициализация кастомных модалок
        const on = (element, eventName, selector, fn) => {

            if (!element) {
                return false;
            }

            element.addEventListener(eventName, (event) => {

                const possibleTargets = element.querySelectorAll(selector);
                const target = event.target;

                for (let i = 0; i < possibleTargets.length; i += 1) {
                    let el = target;
                    const p = possibleTargets[i];

                    while (el && el !== element) {
                        if (el === p) {
                            return fn.call(p, event);
                        }
                        el = el.parentNode;
                    }
                }
            });
        }

        on(document.body, 'click', '.js-modal', (e) => {
            e.preventDefault();
            mmodal(e.target, bindModalForm);
            e.stopPropagation();
        });

        // breadcrumbs
        const breadcrumbs = new Breadcrumbs(document.querySelector('.breadcrumbs'), '(max-width: 1150px)');

        // привязка форм
        const forms = document.querySelectorAll('.js-form');
        for (const form of forms) {
            bindForm(form);
        }

        // схема в технологиях
        const bindTechScheme = (node) => {
            if (!node) {
                return false;
            }

            const items = node.querySelectorAll('.techs__scheme-item');

            for (const item of items) {
                item.addEventListener('mouseenter', () => {
                    item.classList.add('techs__scheme-item_active');
                })
                item.addEventListener('mouseleave', () => {
                    item.classList.remove('techs__scheme-item_active');
                })
            }
        }
        bindTechScheme(document.querySelector('.techs__scheme'));

        // пагинация
        (function () {
            /**
             * Пагинация на ajax
             *
             * .js-ajax-remove - блоки которые должны удаляться ы сразу при переходе на 2ю и след страницы
             * #js-catalog-items - блок в рамках которого идут подмены контента
             * .js-pagination - блок пагинации клики на который обрабатывает скрипт
             * .js-pagination-catalog-list - контейнер списка товаров
             */


        /**
         * В ajaxReady пишем весь код который толжен произойти после догрузки нового контента -
         * инициализации слайдеров на новых элементах,прокраска сердечек в избранное, удаление блоков и тд...
         */
        const ajaxReady = function () {
            document.querySelectorAll('.js-ajax-remove').forEach((item) => {
                item.remove();
            });
            if (window.matchMedia('(max-width: 1000px)').matches) {
                destroyCatalogAdaptive(document.querySelector('.js-catalog-table'));
                bindCatalogAdaptive(document.querySelector('.js-catalog-table'));
            }

            initCollapseTable();
            initPreviewSlider();

            if(HidePrice){
                HidePrice.setHidePrice();
            }


            setTimeout(function(){
                initCollapseText();
            }, 3000);

        }

        const setH1 = function (url) {
            let page = /.*PAGEN_\d\=(\d)/.exec(url);

            document.querySelectorAll('h1 .js-pagen').forEach(
                function (item) {
                    item.remove();
                }
            );

            if (page != null && document.querySelector('h1')) {
                document.querySelector('h1')
                    .insertAdjacentHTML('beforeend', '<span class="js-pagen">. Страница №' + page[1] + '</span>');
            }
        }

        const mainContentBox = document.getElementById('js-catalog-items');

        on(mainContentBox, 'click', '.js-pagination a', function (e) {
            const $btn = this;
            mainContentBox.classList.add('loading');
            const url = $btn.getAttribute('href');

            fetch(url, {
                method: 'POST',
                body: JSON.stringify({
                    'ajax': '1'
                })
            })
                .then(response => response.text())
                .then(
                    function (htmlContent) {
                        setH1(url);

                        const contentResponse = document.createElement('div');
                        contentResponse.insertAdjacentHTML('beforeend', htmlContent);

                        if ($btn.classList.contains('js-more')) {
                            mainContentBox.querySelector('.js-pagination-catalog-list').insertAdjacentHTML('beforeend', contentResponse.querySelector('.js-pagination-catalog-list').innerHTML);
                        } else {
                            mainContentBox.querySelector('.js-pagination-catalog-list').innerHTML = contentResponse.querySelector('.js-pagination-catalog-list').innerHTML;

                            setTimeout(function () {
                                mainContentBox.scrollIntoView({behavior: "smooth"});
                            }, 100);
                        }

                        mainContentBox.querySelectorAll('.js-pagination').forEach((item) => {
                            item.innerHTML = contentResponse.querySelector('.js-pagination').innerHTML;
                        });

                        ajaxReady();
                        mainContentBox.classList.remove('loading');
                    })


            e.stopPropagation();
            e.preventDefault();
        });

    })();

    // страница каталога - переключение описаний
    const bindCatalogSubsectionDesc = (node) => {
        if (!node) {
            return false;
        }

        const descWrapper = node.parentNode.querySelector('.catalog-section__descriptions');

        if (!descWrapper) {
            return false;
        }

        const descriptions = descWrapper.querySelectorAll('.cat-subsection-desc');

        const showDescriptions = (show) => {
            [...descriptions].map((el, index) => {
                if (index !== show) {
                    el.classList.add('cat-subsection-desc_hidden');
                } else {
                    el.classList.remove('cat-subsection-desc_hidden');
                }
            });
        }

        showDescriptions(0);

        const markers = node.querySelectorAll('.subsections-item');

        [...markers].map((el, index) => {
            el.addEventListener('mouseenter', () => {
                showDescriptions(index);
            })
        })

    }

    bindCatalogSubsectionDesc(document.querySelector('.catalog-section__subsections'));



    initCollapseTable();



    initCollapseText();



    initPreviewSlider();

})
const pageReady = function(e) {
   let lazyLoadBlock = new LazyLoadBlock();
}
document.addEventListener("DOMContentLoaded", pageReady);
window.addEventListener('scroll',function(){
    fixHeader()

})